import { READY_MODULE_VIDEOS } from '../../../constants/readyModuleVideos'
import { getUserData } from '../../../services/API'

const DEFAULT_LOCALE = 'en-us'

// The Tutor videos split at the end of third grade: one covers K-3, the other 4-8.
// This deliberately does not use ThemingService's grade bands — the split falls inside
// the MEDIUM band (grades 3-5), so no combination of bands expresses it.
const HIGHEST_K_3_GRADE = 3

/**
 * Picks the Ready Module intro video for this session.
 *
 * @param {object} options
 * @param {boolean} options.forcedAssessment - true when this session is an assessment.
 * @returns {string|null} the video URL, or null when none is configured.
 */
export default function getIntroVideoURL({ forcedAssessment }) {
    const { actualGrade, locale } = getUserData()

    const localizedVideos = forcedAssessment
        ? READY_MODULE_VIDEOS.ASSESS
        : tutorVideosForGrade(actualGrade)

    // Fall back to English rather than showing nothing if a student turns up on a locale
    // the videos were never produced in.
    return localizedVideos[locale] || localizedVideos[DEFAULT_LOCALE] || null
}

function tutorVideosForGrade(actualGrade) {
    // An unknown grade gets the younger video: the simpler explanation is the safer
    // mistake for an older student, where the reverse is not.
    if (actualGrade === undefined || actualGrade === null) return READY_MODULE_VIDEOS.TUTOR_K_3

    return actualGrade <= HIGHEST_K_3_GRADE
        ? READY_MODULE_VIDEOS.TUTOR_K_3
        : READY_MODULE_VIDEOS.TUTOR_4_8
}
